import About from "../Components/About/About";
import CoreBusiness from "../Components/CoreBusiness/CoreBusiness";
import Featured from "../Components/Featured/Featured";
import Hero from "../Components/Hero/Hero";
import How from "../Components/How/How";
import InstagramSlider from "../Components/IGSection/IGSection";
import LatestCollections from "../Components/LatestCollections/LatestCollections";
import Stats from "../Components/Stats/Stats";
import Testimonial from "../Components/Testimonials/Testimonials";
import Video from "../Components/Video/Video";
import WhyUs from "../Components/WhyUs/WhyUs";
import data from "../data.json";
import FadeInWhenVisible from "../Utilities/FadeInWhenVisible";

export default function HomePage() {
  return (
    <div className="App">
      <FadeInWhenVisible>
        <Hero />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.2}>
        <About />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <Stats />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <WhyUs />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <LatestCollections />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <CoreBusiness />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <How />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <Featured />
      </FadeInWhenVisible>

      {/* <Video /> */}
      <FadeInWhenVisible delay={0.4}>
        <Testimonial testimonialData={data} />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <InstagramSlider />
      </FadeInWhenVisible>
    </div>
  );
}
